import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        border: `3px solid ${theme.palette.error.light}`,
        borderRadius: "10px",
        width: "95%",
        flex: 1,
        minHeight: 0,
        gap: theme.spacing(5),
        margin: `${theme.spacing(5)} auto 0`,
    },
    title: {
        fontWeight: "700 !important",
    },
    subtitle: {
        color: theme.palette.error.light,
    },
    icon: {
        height: "100px !important",
        width: "100px !important",
        color: theme.palette.info.main,
    },
}));
